/* eslint-disable no-unused-vars */
import React, {useEffect, useState} from "react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FrontBanner from "@/assets/images/front-banner.svg";
import stars from "@/assets/images/stars.svg";
import {useHistory} from "react-router-dom";
import {oneTimePlans} from "@/utils/constants";
import CartSidebar from "./CartSidebar";
import "./index.scss";
import MembershipTap from "@/pages/shop-item/components/MembershipTab";
import useUserCredits from "@/hooks/useUserCredits";
import {ROUTESLIST} from "@/static/urls";
import {cloneDeep} from "lodash";


const ShopItemPage = (props, {userDashboardView = false}) => {
    const history = useHistory();
    const [cartOpen, setCartOpen] = useState(false);
    const [cartItems, setCartItems] = useState([]);
    const [discounts] = useState({
        samples: 500,
        syncs: 50,
    });
    const {credits, loading: creditsLoading, error: creditsError} = useUserCredits();
    const [userCameFrom, setUserCameFrom] = useState(
        props?.history?.location?.state?.from
    );
    const [selected, setSelected] = useState("subscription");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        if (credits.sampleClearances > 0) {
            setSelected("one-time-service");
        }
    }, [credits.sampleClearances]);
    useEffect(() => {

        setUserCameFrom(props?.history?.location?.state?.from);
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const checkForCartStatus = (product) => {
        if (userCameFrom) {
            return true;
        }
        const productDestinations = {
            'full-clearance-package': ROUTESLIST.CLEAR_SAMPLE,
            'digital-license': ROUTESLIST.UPLOAD_DIGITAL_LICENSE,
            'single-sample-review': ROUTESLIST.UPLOAD_REVIEW
        }
        history.push(productDestinations[product.id])
        return false;
    }
    const addToCart = (productToAdd) => {
        history.push(`/checkout`)
        return;
        if (!checkForCartStatus(productToAdd)) {
            return;
        }
        localStorage.removeItem("cart")
        let cart = JSON.parse(localStorage.getItem("cart")) || [];

        // Clone product before adding to cart (duplicates are currently allowed)
        const newProduct = cloneDeep(productToAdd);

        // Only apply subscription-based discount if NOT already handled by year duration logic above
        if (newProduct.duration !== "year") {
            if (newProduct.id === "full-clearance-package") {
                if (credits.sampleClearances > 0) {
                    const originalPrice = parseInt(newProduct.price);
                    newProduct.price = originalPrice - parseInt(discounts.samples);
                    newProduct.originalPrice = originalPrice; // Store original price
                }
            }
            if (newProduct.id === "single-sample-review") {
                if (credits.sampleClearances > 0) {
                    newProduct.price = parseInt(newProduct.price) - parseInt(discounts.syncs);
                    newProduct.originalPrice = parseInt(newProduct.price) + parseInt(discounts.syncs); // Store original price
                }
            }
        }
        cart.push(newProduct);

        localStorage.setItem("cart", JSON.stringify(cart));
        setCartItems(cart);
        history.push(`/checkout`)
        // setCartOpen(true);
        // console.log("Updated cart:", cart);
    };

    const isOptionDisabled = (plan) => {
        // console.log(userCameFrom);
        if (userCameFrom === "sample-review") {
            // If sample review, disable Clearance Package and Cover Song
            return ["full-clearance-package", "cover-song"].includes(plan.id);
        } else if (userCameFrom === "add-sync" || userCameFrom === "add-sample") {
            // If add-sync or add-sample, disable Sample Reviews and Cover Song
            return ["single-sample-review", "cover-song"].includes(plan.id);
        }
        return false;
    };


    if (creditsError) {
        console.error('Error loading credits:', creditsError);
        // Continue rendering even if credits fail to load
    }

    return (
        <main className="page product-page">
            <div
                className="product-section"
                style={userDashboardView ? {margin: "0rem"} : {margin: "5rem"}}
            >

                <div
                    className="product-header"
                    // style={
                    //   userDashboardView
                    //     ? { justifyContent: "center" }
                    //     : { justifyContent: "space-between" }
                    // }
                    style={{
                        justifyContent: isMobile
                            ? "center"
                            : userDashboardView
                                ? "center"
                                : "space-between",
                    }}
                >
                    {!userDashboardView && (
                        <div
                            className="back-to-home-section"
                            onClick={() => {
                                history.push("/userdashboard/mysamples");
                            }}
                        >
                            <ArrowBackIcon/>
                            {/* <h3>Back to home</h3> */}
                        </div>
                    )}

                    <div className="back-to-home-section-image">
                        <img src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg" alt="front-banner"/>
                    </div>
                    {!userDashboardView && (
                        <div className="back-to-home-section">
                            {/* <img src={avtar} alt="Avatar" className="avatar" /> */}
                        </div>
                    )}
                </div>

                <div className="video-responsive-container">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/ZuQSNr4v8Wk?si=qPdQz8q5IVSM17Nk"
                        title="Ample Samples Service Explanation"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen></iframe>
                </div>

                <div className="plan-header">
                    <p>
                        For brands, filmmakers, artists and labels who clear multiple songs yearly.
                        <br/>
                        Ideal for professionals who are managing recurring sync and sample projects.
                    </p>
                    <h3>
                        Built for independent music professionals who want faster, smarter, and more affordable clearances.
                    </h3>
                    <p className="save-up-to">
                        Save $7,000 across 15 clearances with a Membership.
                    </p>
                    {!creditsLoading && credits.hasSubscription && (
                        <p className="save-up-to">
                            {credits.sampleClearances > 0
                                ? `Your membership has ${credits.sampleClearances} discounted clearance${credits.sampleClearances === 1 ? "" : "s"} left.`
                                : "You have used all your discounted clearances — clearances now bill at the standard rate."}
                        </p>
                    )}
                </div>

                {creditsLoading ? (
                    <>
                        <div className="subsciption-tab-container">
                            <div className="loading-skeleton"
                                 style={{height: '50px', width: '300px', margin: '0 auto', borderRadius: '30px'}}></div>
                        </div>

                        <div className="pricing-container">
                            {[1, 2, 3].map((i) => (
                                <div key={i} className="pricing-card" style={{minHeight: '444px'}}>
                                    <div className="loading-skeleton"
                                         style={{height: '30px', width: '70%', marginBottom: '20px'}}></div>
                                    <div className="loading-skeleton"
                                         style={{height: '40px', width: '50%', marginBottom: '15px'}}></div>
                                    <div className="loading-skeleton"
                                         style={{height: '60px', width: '100%', marginBottom: '15px'}}></div>
                                    <div className="divider"></div>
                                    <div className="loading-skeleton"
                                         style={{height: '20px', width: '90%', margin: '10px 0'}}></div>
                                    <div className="loading-skeleton"
                                         style={{height: '20px', width: '85%', margin: '10px 0'}}></div>
                                    <div className="loading-skeleton"
                                         style={{height: '20px', width: '80%', margin: '10px 0'}}></div>
                                    <div style={{flex: 1}}></div>
                                    <div className="loading-skeleton"
                                         style={{height: '40px', width: '100%', marginTop: '20px'}}></div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        <div className="subsciption-tab-container">
                            <div className="subscription-tab-wrapper">
                                <button
                                    className={`${selected === "subscription"
                                        ? "subscription-btn-selected"
                                        : "subscription-btns"
                                    }`}
                                    onClick={() => setSelected("subscription")}
                                >
                                    Membership
                                </button>

                                <button
                                    className={`${selected === "one-time-service"
                                        ? "subscription-btn-selected"
                                        : "subscription-btns"
                                    }`}
                                    onClick={() => setSelected("one-time-service")}
                                >
                                    One-time Service
                                </button>

                            </div>
                        </div>

                        {selected === "subscription" ? <MembershipTap/> : (
                            <div className="pricing-container">
                                {oneTimePlans.map((plan) => (
                                    <div
                                        className={`pricing-card ${plan.id}`}
                                        key={plan.id}
                                    >
                                        <div className="pricing-top-section">
                                            {plan.recommended ? (
                                                <div className="recommended">
                                                    <h2>{plan.plan_name}</h2>
                                                    <div className="recommended-chip">
                                                        <img alt="Recommended Star" src={stars}/>
                                                        <p className="">Recommended</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <h2>{plan.plan_name}</h2>
                                            )}
                                            {plan?.price && (
                                                <div className="price">

                                                    {`$${plan.price?.toLocaleString()}`}
                                                    <sup>{plan.duration ? ` /${plan.duration}` : ""}</sup>
                                                </div>
                                            )}
                                            <p><span
                                                className="font-bold block mb-2">Who it's for:</span>{plan.plan_description}
                                            </p>
                                        </div>
                                        <div className="feature-container">
                                            <ul className="features">
                                                {plan.features.map((feature, index) => (
                                                    <li key={index}>{feature}</li>
                                                ))}
                                            </ul>
                                            {plan.contact ? (
                                                <button
                                                    onClick={() => history.push("/contact")}
                                                    disabled={isOptionDisabled(plan)}
                                                >
                                                    Contact us
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => addToCart(plan)}
                                                    disabled={isOptionDisabled(plan)}
                                                >
                                                    {isOptionDisabled(plan) ? "Not Available" : "Buy"}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
                {/* <div className="pricing-container">
          {plans.map((plan) => (
            <div className={`pricing-card ${plan.id}`} key={plan.id}>
              {plan.recommended ? (
                <div className="recommended">
                  <h2>{plan.name}</h2>
                  <div className="recommended-chip">
                    <img src={stars} />
                    <p className="">Recommended</p>
                  </div>
                </div>
              ) : (
                <h2>{plan.name}</h2>
              )}
              {plan?.price && (
                <div className="price">
                  {plan.price ? (
                    `$${plan.price?.toLocaleString()}`
                  ) : (
                    <span>&nbsp;</span>
                  )}
                  <sup>{plan.duration ? ` /${plan.duration}` : ""}</sup>
                </div>
              )}
              <p>{plan.description}</p>
              <div className="divider"></div>
              <ul className="features">
                {plan.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              {plan.contact ? (
                <button onClick={() => history.push("/contact")}>
                  Contact us
                </button>
              ) : (
                <button onClick={() => goToShopCart(plan.id)}>
                  {plan.recommended ? "Recommended" : "Select"}
                </button>
              )}
            </div>
          ))}
        </div> */}
                <div className="divider"></div>
                <div className="why-choose-section">
                    <div className="why-choose-center">
                        <h3>Why Choose Ample Samples™?</h3>
                        <p>
                            At Ample Samples™, we understand the complexities and challenges
                            faced by music creators, producers, and media companies when it
                            comes to licensing and clearing samples. Our all-in-one solution
                            streamlines this process, allowing you to focus on your creativity
                            while we handle the legal intricacies. Here's why we stand out:
                        </p>
                    </div>
                </div>
                <div className="review-video">
                    <div className="review-video__inner">
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/5hqbvLuArkE?si=2DfnU-zmbG_LwNaw"
                            title="YouTube video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            style={{
                                border: "none",
                            }}
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
                {/*<div className="plan-detail-section">
                    <h3>Which Plan is for me?</h3>
                    <div className="card-parent">
                        {plans.map((plan) => (
                            <div className="plan-card-details" key={plan.id}>
                                <h3>{plan.name}:</h3>
                                <p>{plan?.details}</p>
                                 <p>{plan.description}</p>
                {plan.price && <p>Price: ${plan.price} USD</p>}
                            </div>
                        ))}
                    </div>
                </div>*/}
            </div>
            <CartSidebar
                open={cartOpen}
                onClose={() => setCartOpen(false)}
                items={cartItems}
            />
        </main>
    );
};

export default ShopItemPage;
